/**
 * FinancialVisibilityGuard — gate dei riepiloghi finanziari (07/07/2026)
 *
 * Wrapper che renderizza i figli SOLO se il ruolo corrente è ammesso
 * ai riepiloghi finanziari (amministratore, responsabile). Altrimenti
 * ritorna `null` — nessun placeholder, nessuno spazio vuoto, il layout
 * si compatta naturalmente attorno.
 *
 * Uso:
 *   <FinancialVisibilityGuard operatorRole={operatorRole}>
 *     <KpiTotali />
 *     <KpiIncassato />
 *     <KpiResiduo />
 *   </FinancialVisibilityGuard>
 *
 * Ogni futuro dashboard/analytics/cash-flow/marginality panel deve
 * riusare questo componente invece di introdurre check di ruolo inline.
 */
import React from "react";
import { canViewFinancialDashboard } from "@/lib/permissions";

export function FinancialVisibilityGuard({ operatorRole, children }) {
  if (!canViewFinancialDashboard(operatorRole)) return null;
  // Wrapping in Fragment: children mantengono la loro posizione nel flow
  // del parent (nessun div extra che potrebbe rompere flex/grid layout).
  return <>{children}</>;
}

export default FinancialVisibilityGuard;
